// import Viewer360 from "../../../components/Viewer360"
import { memo, useCallback, useRef } from "react"
import { useStore } from "../State/Store"
import { AptModal, AptModalBackdrop } from "./ApartmentCard.style"
import FavouriteCard2 from "../../FavouriteCard/FavouriteCard2"

function ApartmentCard({ id }) {
  let activeApt = useStore(useCallback(state => state.activeApt, []))
  const setActiveApt = useStore(useCallback(state => state.setActiveApt, []))
  const ref = useRef()

  const setShow360 = useStore(state => state.setShow360)

  console.log("activeApt", activeApt)

  if (activeApt) {
    return (
      <>
        <AptModalBackdrop
          onClick={() => setActiveApt(null)}
          opacity={activeApt}
        />

        <AptModal ref={ref} opacity={activeApt}>
          <FavouriteCard2 id={activeApt} setShow360={setShow360} />
        </AptModal>
      </>
      // )
    )
  } else return null
}
export default memo(ApartmentCard)
